import { createRouter, createWebHistory } from 'vue-router'
import Pricing from '@/views/Pricing.vue'

// Lazy-loading für die Routen
// const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const HomePage = () => import(/* webpackChunkName: "homepage" */ '../views/HomePage.vue')
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const Contact = () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
const Services = () => import(/* webpackChunkName: "services" */ '../views/Services.vue')

const PriceCalculator = () => import(/* webpackChunkName: "price-calculator" */ '../components/PriceCalculator.vue')
const CustomerLoginComingSoon = () => import(/* webpackChunkName: "customer-login" */ '../views/CustomerLoginComingSoon.vue')
const PCMeederComingSoon = () => import(/* webpackChunkName: "pc-meeder" */ '../views/PCMeederComingSoon.vue')
const EduMeederComingSoon = () => import(/* webpackChunkName: "edu-meeder" */ '../views/EduMeederComingSoon.vue')
const Impressum = () => import(/* webpackChunkName: "legal" */ '../views/Impressum.vue')
const Datenschutz = () => import(/* webpackChunkName: "legal" */ '../views/Datenschutz.vue')

// Funnel-Komponenten - Legacy
const FunnelStart = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/Start.vue')
const FunnelStep1 = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/Step1.vue')
const FunnelStep2 = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/Step2.vue')
const FunnelStep3 = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/Step3.vue')
const FunnelResult = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/Result.vue')

// Funnel-Auswahl
const FunnelSelection = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/FunnelSelection.vue')

// Geschäftskunden-Funnel
const BusinessStart = () => import(/* webpackChunkName: "business-funnel" */ '../views/funnel/BusinessStart.vue')
const BusinessStep1 = () => import(/* webpackChunkName: "business-funnel" */ '../views/funnel/business/Step1.vue')
const BusinessStep2 = () => import(/* webpackChunkName: "business-funnel" */ '../views/funnel/business/Step2.vue')
const BusinessStep3 = () => import(/* webpackChunkName: "business-funnel" */ '../views/funnel/business/Step3.vue')
// const BusinessResult = () => import(/* webpackChunkName: "business-funnel" */ '../views/funnel/business/Result.vue')

// Privatkunden-Funnel
const PrivateStart = () => import(/* webpackChunkName: "private-funnel" */ '../views/funnel/PrivateStart.vue')
const PrivateStep1 = () => import(/* webpackChunkName: "private-funnel" */ '../views/funnel/private/Step1.vue')
const PrivateStep2 = () => import(/* webpackChunkName: "private-funnel" */ '../views/funnel/private/Step2.vue')
const PrivateStep3 = () => import(/* webpackChunkName: "private-funnel" */ '../views/funnel/private/Step3.vue')
// const PrivateResult = () => import(/* webpackChunkName: "private-funnel" */ '../views/funnel/private/Result.vue')

// Gemeinsame Funnel-Komponenten
const ThankYou = () => import(/* webpackChunkName: "funnel" */ '../views/funnel/ThankYou.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: 'IT-Meeder - Ihre IT-Lösungen aus einer Hand' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: 'Über uns - IT-Meeder' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Kontakt - IT-Meeder' }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: { title: 'IT-Dienstleistungen - IT-Meeder' }
  },
  {
    path: '/preiskalkulator',
    name: 'PriceCalculator',
    component: PriceCalculator,
    meta: { title: 'IT-Wartungsvertrag Preiskalkulator - IT-Meeder' }
  },
  
  // Customer Login Coming Soon
  {
    path: '/customer-login-coming-soon',
    name: 'CustomerLoginComingSoon',
    component: CustomerLoginComingSoon,
    meta: { title: 'Kundenlogin - In Kürze verfügbar - IT-Meeder' }
  },
  
  // Legal Pages
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    meta: { title: 'Impressum - IT-Meeder' }
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: Datenschutz,
    meta: { title: 'Datenschutzerklärung - IT-Meeder' }
  },
  
  // Coming Soon Pages
  {
    path: '/pc-meeder',
    name: 'PCMeederComingSoon',
    component: PCMeederComingSoon,
    meta: { title: 'PC-Meeder - Demnächst verfügbar' }
  },
  {
    path: '/edu-meeder',
    name: 'EduMeederComingSoon',
    component: EduMeederComingSoon,
    meta: { title: 'EDU-Meeder - Demnächst verfügbar' }
  },
  
  // Neue Funnel-Auswahl Route
  {
    path: '/funnel',
    name: 'FunnelSelection',
    component: FunnelSelection,
    meta: { title: 'IT-Bedarfsanalyse - Auswahl - IT-Meeder' }
  },
  
  // Legacy Funnel-Routen - für Abwärtskompatibilität
  {
    path: '/funnel/start',
    name: 'FunnelStart',
    component: FunnelStart,
    meta: { title: 'IT-Bedarfsanalyse - IT-Meeder' }
  },
  {
    path: '/funnel/step1',
    name: 'FunnelStep1',
    component: FunnelStep1,
    meta: { title: 'IT-Bedarfsanalyse - Schritt 1' }
  },
  {
    path: '/funnel/step2',
    name: 'FunnelStep2',
    component: FunnelStep2,
    meta: { title: 'IT-Bedarfsanalyse - Schritt 2' }
  },
  {
    path: '/funnel/step3',
    name: 'FunnelStep3',
    component: FunnelStep3,
    meta: { title: 'IT-Bedarfsanalyse - Schritt 3' }
  },
  {
    path: '/funnel/result',
    name: 'FunnelResult',
    component: FunnelResult,
    meta: { title: 'Ihr persönliches IT-Angebot' }
  },
  
  // Geschäftskunden-Funnel
  {
    path: '/funnel/business',
    name: 'BusinessStart',
    component: BusinessStart,
    meta: { title: 'IT-Bedarfsanalyse für Unternehmen - IT-Meeder' }
  },
  {
    path: '/funnel/business/step1',
    name: 'BusinessStep1',
    component: BusinessStep1,
    meta: { title: 'IT-Bedarfsanalyse für Unternehmen - Schritt 1' }
  },
  {
    path: '/funnel/business/step2',
    name: 'BusinessStep2',
    component: BusinessStep2,
    meta: { title: 'IT-Bedarfsanalyse für Unternehmen - Schritt 2' }
  },
  {
    path: '/funnel/business/step3',
    name: 'BusinessStep3',
    component: BusinessStep3,
    meta: { title: 'IT-Bedarfsanalyse für Unternehmen - Schritt 3' }
  },
  {
    path: '/funnel/business/result',
    name: 'BusinessResult',
    component: FunnelResult,
    meta: { title: 'Ihr persönliches Unternehmensangebot' }
  },
  {
    path: '/funnel/business/thank-you',
    name: 'BusinessThankYou',
    component: ThankYou,
    meta: { title: 'Vielen Dank für Ihre Anfrage - IT-Meeder' }
  },
  
  // Privatkunden-Funnel
  {
    path: '/funnel/private',
    name: 'PrivateStart',
    component: PrivateStart,
    meta: { title: 'IT-Bedarfsanalyse für Privatanwender - IT-Meeder' }
  },
  {
    path: '/funnel/private/step1',
    name: 'PrivateStep1',
    component: PrivateStep1,
    meta: { title: 'IT-Bedarfsanalyse für Privatanwender - Schritt 1' }
  },
  {
    path: '/funnel/private/step2',
    name: 'PrivateStep2',
    component: PrivateStep2, // Verwende die neue Komponente
    meta: { title: 'IT-Bedarfsanalyse für Privatanwender - Schritt 2' }
  },
  {
    path: '/funnel/private/step3',
    name: 'PrivateStep3',
    component: PrivateStep3, // Verwende die neue Komponente
    meta: { title: 'IT-Bedarfsanalyse für Privatanwender - Schritt 3' }
  },
  {
    path: '/funnel/private/result',
    name: 'PrivateResult',
    component: FunnelResult, // Vorübergehend den Legacy-Schritt verwenden
    meta: { title: 'Ihr persönliches IT-Angebot' }
  },
  {
    path: '/funnel/private/thank-you',
    name: 'PrivateThankYou',
    component: ThankYou,
    meta: { title: 'Vielen Dank für Ihre Anfrage - IT-Meeder' }
  },
  
  // Pricing Route
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: { title: 'Preise & Leistungen - IT-Meeder' }
  },

  
  // 404 Route
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Dynamischer Titel basierend auf der Route
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'IT-Meeder'
  next()
})

export default router 